import { useNuxtApp } from '#imports'

export default function (props) {
  if (process.server)
    return console.debug(`🚀 ~ file: useToast.js:4 ~ props:`, props)

  // https://www.figma.com/design/04SlAQDbb2M2yNzPgjjpvF/Genoplan-X-(Mobile)-1.1?node-id=9338-27430&t=3ajDeqiM5T6HSVu1-4
  props.closable = props.closable ?? false
  if (!props.life) {
    if (props.severity == 'success') props.life = 1500
    else if (props.severity == 'error') props.life = 10000
    else props.life = 2000
  }

  const { vueApp } = useNuxtApp()
  vueApp.config.globalProperties.$toast.add(props) // use Global toast in app.vue
}
